export function getButtonDetails(route: string) {
    switch(route) {
        case '/dashboard/dashboard-details': 
            return [
                {
                    name: 'Search Cyber Score',
                    route: '/dashboard/search-score',
                    isDisabled: false
                }
            ];
        default: return [];
    }
}